// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loan-details {
  padding: 43px 40px;
  overflow: hidden; }
  .loan-details .loan-details-box-change-terms {
    display: flex;
    border-radius: 10px;
    border: 1px solid #DDAA42;
    background: #FFF9EE;
    margin-bottom: 10px; }
    .loan-details .loan-details-box-change-terms img {
      padding: 15px 16px 20px 22px; }
    .loan-details .loan-details-box-change-terms span {
      padding: 16px 0px 16px;
      font-family: Inter;
      font-weight: 400;
      font-size: 16px;
      line-height: 23.2px;
      letter-spacing: 0%;
      color: #775614; }
  .loan-details .loan-details-top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 8px;
    border-bottom: 1px solid #929FB0;
    margin-bottom: 22px; }
    .loan-details .loan-details-top-bar .loan-info {
      margin-bottom: 2px; }
      .loan-details .loan-details-top-bar .loan-info .loan-borrower-name {
        color: #404859;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        /* 133.333% */
        letter-spacing: 0.24px;
        text-transform: uppercase; }
      .loan-details .loan-details-top-bar .loan-info .loan-address {
        color: #404859;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0.24px;
        text-transform: uppercase; }
    .loan-details .loan-details-top-bar .close-button-container {
      cursor: pointer;
      color: #404859;
      text-align: right;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      /* 133.333% */
      letter-spacing: 0.24px;
      text-transform: uppercase; }
  .loan-details .loan-details-first-row {
    display: flex;
    justify-content: space-between;
    align-items: end;
    margin-bottom: 24px;
    position: relative;
    padding-bottom: 15px; }
    .loan-details .loan-details-first-row::after {
      content: "";
      display: block;
      border: 1px solid #CCD3DB;
      width: 110%;
      position: absolute;
      bottom: 0;
      left: -40px; }
    .loan-details .loan-details-first-row .loan-number {
      color: #404859;
      line-height: 30px; }
    .loan-details .loan-details-first-row .loan-progress .loan-info .loan-status {
      color: #404859;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px;
      letter-spacing: 0.36px; }
    .loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date {
      color: #404859;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0.36px; }
      .loan-details .loan-details-first-row .loan-progress .loan-info .loan-closing-date b {
        color: #404859;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0.36px; }
    .loan-details .loan-details-first-row .loan-progress .loan-address {
      color: #2A2F3C;
      font-family: Inter;
      font-size: 32px;
      font-style: normal;
      font-weight: 600;
      line-height: 40px; }
    .loan-details .loan-details-first-row .loan-progress .loan-progress-section {
      margin-bottom: 20px; }
      .loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container {
        display: flex;
        flex-direction: row; }
        .loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container > * {
          flex: 1 1;
          margin-right: 8px; }
        .loan-details .loan-details-first-row .loan-progress .loan-progress-section .loan-progress-items-container .loan-progress-item-caption {
          color: #404859;
          font-family: Inter;
          font-size: 10px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          white-space: nowrap;
          margin-bottom: 6px;
          flex: 0.13 1; }
    .loan-details .loan-details-first-row .loan-progress .loan-values-summary {
      margin-bottom: 8px;
      color: #404859;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 115%; }
      .loan-details .loan-details-first-row .loan-progress .loan-values-summary span {
        cursor: pointer;
        color: #5E8EB7;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 115%; }
    .loan-details .loan-details-first-row .placeholder {
      flex: 3 1; }
    .loan-details .loan-details-first-row .borrower-card {
      flex: 1 1; }
  .loan-details .loan-details-main {
    display: flex; }
    .loan-details .loan-details-main > * {
      flex: 1 1;
      box-sizing: border-box; }
    .loan-details .loan-details-main .left-column {
      padding-right: 15px; }
      .loan-details .loan-details-main .left-column > * {
        margin-bottom: 16px; }
        .loan-details .loan-details-main .left-column > *:last-of-type {
          margin-bottom: 0px; }
      .loan-details .loan-details-main .left-column .loan-summary {
        display: flex;
        justify-content: space-between; }
        .loan-details .loan-details-main .left-column .loan-summary .closing {
          flex: 1 1;
          border-radius: 10px;
          border: 1px solid #AFBDCC;
          padding: 16px 20px;
          margin-right: 16px; }
          .loan-details .loan-details-main .left-column .loan-summary .closing .label {
            color: #2A2F3C;
            font-family: Inter;
            font-size: 22px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-bottom: 18px; }
          .loan-details .loan-details-main .left-column .loan-summary .closing .calendar {
            width: 128px;
            border-radius: 10px;
            border: 1px solid #5E8EB7;
            background: #F5FAFF;
            margin-bottom: 8px; }
            .loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled {
              border: 1px solid #929FB0;
              background: #EFF3F5; }
              .loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .date {
                color: #48759A;
                border-bottom: 1px solid #929FB0; }
              .loan-details .loan-details-main .left-column .loan-summary .closing .calendar.disabled .day {
                color: #DFE4EB; }
            .loan-details .loan-details-main .left-column .loan-summary .closing .calendar .date {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 6px 26px;
              border-bottom: 1px solid #5E8EB7;
              color: #48759A;
              font-family: Inter;
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
              line-height: 16px;
              /* 114.286% */ }
            .loan-details .loan-details-main .left-column .loan-summary .closing .calendar .day {
              height: 68px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #355C7D;
              font-family: Inter;
              font-size: 32px;
              font-style: normal;
              font-weight: 600;
              line-height: normal; }
          .loan-details .loan-details-main .left-column .loan-summary .closing .caption {
            color: #404859;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            /* 128.571% */ }
            .loan-details .loan-details-main .left-column .loan-summary .closing .caption b {
              font-weight: 600;
              color: #404859; }
        .loan-details .loan-details-main .left-column .loan-summary .content-box {
          flex: 5 1; }
    .loan-details .loan-details-main .right-column {
      padding-left: 15px; }
      .loan-details .loan-details-main .right-column > * {
        margin-bottom: 16px; }
      .loan-details .loan-details-main .right-column .borrower-tasks > .title {
        margin-bottom: 8px;
        color: #2A2F3C;
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px; }
      .loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-status-container {
        display: flex;
        margin-bottom: 16px; }
      .loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 7px; }
        .loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 3px;
          margin-left: 16px;
          color: #6E7889;
          text-align: right;
          font-family: Inter;
          font-size: 12px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          letter-spacing: 0.24px;
          text-transform: uppercase; }
          .loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-actions > div svg {
            position: relative; }
      .loan-details .loan-details-main .right-column .borrower-tasks .borrower-tasks-list {
        margin-bottom: 17px; }
      .loan-details .loan-details-main .right-column .action-button {
        border: 1px solid #162E43;
        background: #162E43;
        text-align: center;
        border-radius: 6px;
        padding: 14px 0px;
        margin-bottom: 30px;
        color: #F5FAFF;
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0.24px; }
        .loan-details .loan-details-main .right-column .action-button:hover {
          background-color: #EBF6FF !important;
          border-color: #EBF6FF !important;
          color: #355D7D !important; }
      .loan-details .loan-details-main .right-column .loan-documents > .title {
        margin-bottom: 8px;
        color: #2A2F3C;
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px; }
      .loan-details .loan-details-main .right-column .approve-loan {
        padding: 14px 0px;
        text-align: center;
        border-radius: 6px;
        border: 1px solid #DFE4EB;
        background: #DFE4EB;
        color: #929FB0;
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0.24px; }

.loan-progress-item .caption {
  color: #404859;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  text-align: center;
  margin-bottom: 4px; }

.loan-progress-item .loan-progress-bar {
  width: 100%;
  height: 6px;
  border-radius: 16px;
  background: #DFE4EB; }

.content-box {
  border-radius: 10px;
  border: 1px solid #AFBDCC;
  padding: 16px 18px; }
  .content-box .label {
    color: #2A2F3C;
    font-family: Inter;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 10px; }
  .content-box .content {
    border-left: 1px solid #97BCF0;
    padding: 2px 0px;
    padding-left: 12px; }
    .content-box .content .portfolio p {
      color: #2A2F3C;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 4px; }
    .content-box .content .item {
      margin-bottom: 8px; }
      .content-box .content .item:last-of-type {
        margin-bottom: 0px; }
    .content-box .content .item-row {
      color: #404859;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      display: flex;
      align-items: center;
      justify-content: space-between; }
      .content-box .content .item-row .field {
        font-size: 14px; }
        @media (max-width: 1450px) {
          .content-box .content .item-row .field {
            font-size: 13px; } }
        .content-box .content .item-row .field:nth-child(2) {
          margin-right: 15px;
          margin-left: auto;
          font-style: italic; }
      .content-box .content .item-row .value i {
        color: #6E7889; }
      .content-box .content .item-row .value span {
        cursor: pointer;
        color: #5E8EB7;
        text-align: right;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal; }
        @media (max-width: 1450px) {
          .content-box .content .item-row .value span {
            font-size: 13px; } }
      .content-box .content .item-row.extra {
        margin-top: 8px;
        padding-left: 16px;
        color: #2A2F3C;
        font-family: Inter;
        font-size: 14px;
        font-style: italic;
        font-weight: 400;
        line-height: normal; }
        .content-box .content .item-row.extra .value {
          color: #6E7889; }
`, "",{"version":3,"sources":["webpack://./src/scenes/Private/Dashboard/components/LoanDetails/LoanDetails.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAElB,gBAAgB,EAAA;EAHlB;IAMI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB,EAAA;IAVvB;MAaM,4BAA4B,EAAA;IAblC;MAiBM,sBAAsB;MACtB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,cAAc,EAAA;EAvBpB;IA4BI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAE9B,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB,EAAA;IAlCvB;MAqCM,kBAAkB,EAAA;MArCxB;QAwCQ,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,aAAA;QACA,sBAAsB;QACtB,yBAAyB,EAAA;MAhDjC;QAoDQ,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB;QACtB,yBAAyB,EAAA;IA3DjC;MAgEM,eAAe;MAEf,cAAc;MACd,iBAAiB;MACjB,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,aAAA;MACA,sBAAsB;MACtB,yBAAyB,EAAA;EA3E/B;IAgFI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB,EAAA;IArFxB;MAwFM,WAAW;MACX,cAAc;MACd,yBAAyB;MACzB,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,WAAW,EAAA;IA9FjB;MAkGM,cAAc;MACd,iBAAiB,EAAA;IAnGvB;MA0GU,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,sBAAsB,EAAA;IAhHhC;MAoHU,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,sBAAsB,EAAA;MA1HhC;QA6HY,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB,EAAA;IAnIlC;MAyIQ,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAA;IA9IzB;MAkJQ,mBAAmB,EAAA;MAlJ3B;QAqJU,aAAa;QACb,mBAAmB,EAAA;QAtJ7B;UAyJY,SAAO;UACP,iBAAiB,EAAA;QA1J7B;UA8JY,cAAc;UACd,kBAAkB;UAClB,eAAe;UACf,kBAAkB;UAClB,gBAAgB;UAChB,mBAAmB;UAEnB,mBAAmB;UACnB,kBAAkB;UAElB,YAAU,EAAA;IAxKtB;MA8KQ,kBAAkB;MAElB,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAA;MArLzB;QAwLU,eAAe;QAEf,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAA;IA/L3B;MAsMM,SAAO,EAAA;IAtMb;MA0MM,SAAO,EAAA;EA1Mb;IA+MI,aAAa,EAAA;IA/MjB;MAkNM,SAAO;MACP,sBAAsB,EAAA;IAnN5B;MAuNM,mBAAmB,EAAA;MAvNzB;QA0NQ,mBAAmB,EAAA;QA1N3B;UA6NU,kBAAkB,EAAA;MA7N5B;QAkOQ,aAAa;QACb,8BAA8B,EAAA;QAnOtC;UAsOU,SAAO;UAEP,mBAAmB;UACnB,yBAAyB;UAEzB,kBAAkB;UAElB,kBAAkB,EAAA;UA7O5B;YAgPY,cAAc;YACd,kBAAkB;YAClB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,mBAAmB;YAEnB,mBAAmB,EAAA;UAvP/B;YA2PY,YAAY;YAEZ,mBAAmB;YACnB,yBAAyB;YACzB,mBAAmB;YAEnB,kBAAkB,EAAA;YAjQ9B;cAoQc,yBAAyB;cACzB,mBAAmB,EAAA;cArQjC;gBAwQgB,cAAc;gBACd,gCAAgC,EAAA;cAzQhD;gBA6QgB,cAAc,EAAA;YA7Q9B;cAkRc,aAAa;cACb,mBAAmB;cACnB,uBAAuB;cAEvB,iBAAiB;cAEjB,gCAAgC;cAEhC,cAAc;cACd,kBAAkB;cAClB,eAAe;cACf,kBAAkB;cAClB,gBAAgB;cAChB,iBAAiB;cACjB,aAAA,EAAc;YAhS5B;cAoSc,YAAY;cAEZ,aAAa;cACb,mBAAmB;cACnB,uBAAuB;cAEvB,cAAc;cACd,kBAAkB;cAClB,eAAe;cACf,kBAAkB;cAClB,gBAAgB;cAChB,mBAAmB,EAAA;UA/SjC;YAoTY,cAAc;YACd,kBAAkB;YAClB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,aAAA,EAAc;YA1T1B;cA6Tc,gBAAgB;cAChB,cAAc,EAAA;QA9T5B;UAoUU,SAAO,EAAA;IApUjB;MA0UM,kBAAkB,EAAA;MA1UxB;QA6UQ,mBAAmB,EAAA;MA7U3B;QAkVU,kBAAkB;QAElB,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAA;MAzV3B;QA6VU,aAAa;QACb,mBAAmB,EAAA;MA9V7B;QAkWU,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,kBAAkB,EAAA;QArW5B;UAwWY,eAAe;UAEf,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,QAAQ;UAMR,iBAAiB;UAEjB,cAAc;UACd,iBAAiB;UACjB,kBAAkB;UAClB,eAAe;UACf,kBAAkB;UAClB,gBAAgB;UAChB,mBAAmB;UACnB,sBAAsB;UACtB,yBAAyB,EAAA;UA7XrC;YAgXc,kBAAkB,EAAA;MAhXhC;QAkYU,mBAAmB,EAAA;MAlY7B;QAuYQ,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAElB,kBAAkB;QAClB,iBAAiB;QACjB,mBAAmB;QAEnB,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,sBAAsB,EAAA;QAtZ9B;UAyZU,oCAAoC;UACpC,gCAAgC;UAEhC,yBAAyB,EAAA;MA5ZnC;QAkaU,kBAAkB;QAElB,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAA;MAza3B;QAgbQ,iBAAiB;QACjB,kBAAkB;QAElB,kBAAkB;QAClB,yBAAyB;QACzB,mBAAmB;QAEnB,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,sBAAsB,EAAA;;AAM9B;EAEI,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EAEnB,mBAAmB;EACnB,kBAAkB;EAElB,kBAAkB,EAAA;;AAZtB;EAgBI,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB,EAAA;;AAIvB;EACE,mBAAmB;EACnB,yBAAyB;EAEzB,kBAAkB,EAAA;EAJpB;IAOI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IAEnB,mBAAmB,EAAA;EAdvB;IAkBI,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB,EAAA;IApBtB;MAwBQ,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB,EAAA;IA9B1B;MAmCM,kBAAkB,EAAA;MAnCxB;QAsCQ,kBAAkB,EAAA;IAtC1B;MA2CM,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MAEnB,aAAa;MACb,mBAAmB;MACnB,8BAA8B,EAAA;MApDpC;QAuDQ,eAAe,EAAA;QAEf;UAzDR;YA0DU,eAAe,EAAA,EAQlB;QAlEP;UA8DU,kBAAkB;UAClB,iBAAiB;UACjB,kBAAkB,EAAA;MAhE5B;QAsEU,cAAc,EAAA;MAtExB;QA0EU,eAAe;QAEf,cAAc;QACd,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB,EAAA;QAEnB;UApFV;YAqFY,eAAe,EAAA,EAElB;MAvFT;QA2FQ,eAAe;QACf,kBAAkB;QAElB,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB,EAAA;QAnG3B;UAsGU,cAAc,EAAA","sourcesContent":[".loan-details {\n  padding: 43px 40px;\n\n  overflow: hidden;\n\n  .loan-details-box-change-terms {\n    display: flex;\n    border-radius: 10px;\n    border: 1px solid #DDAA42;\n    background: #FFF9EE;\n    margin-bottom: 10px;\n\n    img {\n      padding: 15px 16px 20px 22px;\n    }\n\n    span {\n      padding: 16px 0px 16px;\n      font-family: Inter;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 23.2px;\n      letter-spacing: 0%;\n      color: #775614;\n    }\n  }\n\n  .loan-details-top-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    padding-bottom: 8px;\n    border-bottom: 1px solid #929FB0;\n    margin-bottom: 22px;\n\n    .loan-info {\n      margin-bottom: 2px;\n\n      .loan-borrower-name {\n        color: #404859;\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 16px;\n        /* 133.333% */\n        letter-spacing: 0.24px;\n        text-transform: uppercase;\n      }\n\n      .loan-address {\n        color: #404859;\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 16px;\n        letter-spacing: 0.24px;\n        text-transform: uppercase;\n      }\n    }\n\n    .close-button-container {\n      cursor: pointer;\n\n      color: #404859;\n      text-align: right;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 16px;\n      /* 133.333% */\n      letter-spacing: 0.24px;\n      text-transform: uppercase;\n    }\n  }\n\n  .loan-details-first-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: end;\n    margin-bottom: 24px;\n    position: relative;\n    padding-bottom: 15px;\n\n    &::after {\n      content: \"\";\n      display: block;\n      border: 1px solid #CCD3DB;\n      width: 110%;\n      position: absolute;\n      bottom: 0;\n      left: -40px;\n    }\n\n    .loan-number {\n      color: #404859;\n      line-height: 30px;\n\n    }\n\n    .loan-progress {\n      .loan-info {\n        .loan-status {\n          color: #404859;\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 16px;\n          letter-spacing: 0.36px;\n        }\n\n        .loan-closing-date {\n          color: #404859;\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 16px;\n          letter-spacing: 0.36px;\n\n          b {\n            color: #404859;\n            font-family: Inter;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 16px;\n            letter-spacing: 0.36px;\n          }\n        }\n      }\n\n      .loan-address {\n        color: #2A2F3C;\n        font-family: Inter;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 40px;\n      }\n\n      .loan-progress-section {\n        margin-bottom: 20px;\n\n        .loan-progress-items-container {\n          display: flex;\n          flex-direction: row;\n\n          >* {\n            flex: 1;\n            margin-right: 8px;\n          }\n\n          .loan-progress-item-caption {\n            color: #404859;\n            font-family: Inter;\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n\n            white-space: nowrap;\n            margin-bottom: 6px;\n\n            flex: 0.13;\n          }\n        }\n      }\n\n      .loan-values-summary {\n        margin-bottom: 8px;\n\n        color: #404859;\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 115%;\n\n        span {\n          cursor: pointer;\n\n          color: #5E8EB7;\n          font-family: Inter;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 115%;\n        }\n      }\n\n    }\n\n    .placeholder {\n      flex: 3;\n    }\n\n    .borrower-card {\n      flex: 1;\n    }\n  }\n\n  .loan-details-main {\n    display: flex;\n\n    >* {\n      flex: 1;\n      box-sizing: border-box;\n    }\n\n    .left-column {\n      padding-right: 15px;\n\n      >* {\n        margin-bottom: 16px;\n\n        &:last-of-type {\n          margin-bottom: 0px;\n        }\n      }\n\n      .loan-summary {\n        display: flex;\n        justify-content: space-between;\n\n        .closing {\n          flex: 1;\n\n          border-radius: 10px;\n          border: 1px solid #AFBDCC;\n\n          padding: 16px 20px;\n\n          margin-right: 16px;\n\n          .label {\n            color: #2A2F3C;\n            font-family: Inter;\n            font-size: 22px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n\n            margin-bottom: 18px;\n          }\n\n          .calendar {\n            width: 128px;\n\n            border-radius: 10px;\n            border: 1px solid #5E8EB7;\n            background: #F5FAFF;\n\n            margin-bottom: 8px;\n\n            &.disabled {\n              border: 1px solid #929FB0;\n              background: #EFF3F5;\n\n              .date {\n                color: #48759A;\n                border-bottom: 1px solid #929FB0;\n              }\n\n              .day {\n                color: #DFE4EB;\n              }\n            }\n\n            .date {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n\n              padding: 6px 26px;\n\n              border-bottom: 1px solid #5E8EB7;\n\n              color: #48759A;\n              font-family: Inter;\n              font-size: 14px;\n              font-style: normal;\n              font-weight: 600;\n              line-height: 16px;\n              /* 114.286% */\n            }\n\n            .day {\n              height: 68px;\n\n              display: flex;\n              align-items: center;\n              justify-content: center;\n\n              color: #355C7D;\n              font-family: Inter;\n              font-size: 32px;\n              font-style: normal;\n              font-weight: 600;\n              line-height: normal;\n            }\n          }\n\n          .caption {\n            color: #404859;\n            font-family: Inter;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 18px;\n            /* 128.571% */\n\n            b {\n              font-weight: 600;\n              color: #404859;\n            }\n          }\n        }\n\n        .content-box {\n          flex: 5;\n        }\n      }\n    }\n\n    .right-column {\n      padding-left: 15px;\n\n      >* {\n        margin-bottom: 16px;\n      }\n\n      .borrower-tasks {\n        >.title {\n          margin-bottom: 8px;\n\n          color: #2A2F3C;\n          font-family: Inter;\n          font-size: 32px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 40px;\n        }\n\n        .borrower-tasks-status-container {\n          display: flex;\n          margin-bottom: 16px;\n        }\n\n        .borrower-tasks-actions {\n          display: flex;\n          align-items: center;\n          justify-content: flex-end;\n          margin-bottom: 7px;\n\n          >div {\n            cursor: pointer;\n\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 3px;\n\n            svg {\n              position: relative;\n            }\n\n            margin-left: 16px;\n\n            color: #6E7889;\n            text-align: right;\n            font-family: Inter;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            letter-spacing: 0.24px;\n            text-transform: uppercase;\n          }\n        }\n\n        .borrower-tasks-list {\n          margin-bottom: 17px;\n        }\n      }\n\n      .action-button {\n        border: 1px solid #162E43;\n        background: #162E43;\n        text-align: center;\n\n        border-radius: 6px;\n        padding: 14px 0px;\n        margin-bottom: 30px;\n\n        color: #F5FAFF;\n        text-align: center;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        letter-spacing: 0.24px;\n\n        &:hover {\n          background-color: #EBF6FF !important;\n          border-color: #EBF6FF !important;\n\n          color: #355D7D !important;\n        }\n      }\n\n      .loan-documents {\n        >.title {\n          margin-bottom: 8px;\n\n          color: #2A2F3C;\n          font-family: Inter;\n          font-size: 32px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 40px;\n        }\n\n        .loan-documents-list {}\n      }\n\n      .approve-loan {\n        padding: 14px 0px;\n        text-align: center;\n\n        border-radius: 6px;\n        border: 1px solid #DFE4EB;\n        background: #DFE4EB;\n\n        color: #929FB0;\n        text-align: center;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        letter-spacing: 0.24px;\n      }\n    }\n  }\n}\n\n.loan-progress-item {\n  .caption {\n    color: #404859;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    white-space: nowrap;\n    text-align: center;\n\n    margin-bottom: 4px;\n  }\n\n  .loan-progress-bar {\n    width: 100%;\n    height: 6px;\n    border-radius: 16px;\n    background: #DFE4EB;\n  }\n}\n\n.content-box {\n  border-radius: 10px;\n  border: 1px solid #AFBDCC;\n\n  padding: 16px 18px;\n\n  .label {\n    color: #2A2F3C;\n    font-family: Inter;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    margin-bottom: 10px;\n  }\n\n  .content {\n    border-left: 1px solid #97BCF0;\n    padding: 2px 0px;\n    padding-left: 12px;\n\n    .portfolio {\n      p {\n        color: #2A2F3C;\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        margin-bottom: 4px;\n      }\n    }\n\n    .item {\n      margin-bottom: 8px;\n\n      &:last-of-type {\n        margin-bottom: 0px;\n      }\n    }\n\n    .item-row {\n      color: #404859;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .field {\n        font-size: 14px;\n\n        @media (max-width: 1450px) {\n          font-size: 13px;\n        }\n\n        &:nth-child(2) {\n          margin-right: 15px;\n          margin-left: auto;\n          font-style: italic;\n        }\n      }\n\n      .value {\n        i {\n          color: #6E7889;\n        }\n\n        span {\n          cursor: pointer;\n\n          color: #5E8EB7;\n          text-align: right;\n          font-family: Inter;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: normal;\n\n          @media (max-width: 1450px) {\n            font-size: 13px;\n          }\n        }\n      }\n\n      &.extra {\n        margin-top: 8px;\n        padding-left: 16px;\n\n        color: #2A2F3C;\n        font-family: Inter;\n        font-size: 14px;\n        font-style: italic;\n        font-weight: 400;\n        line-height: normal;\n\n        .value {\n          color: #6E7889;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
